import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Westtambaram.css';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import {
  FaMapMarkerAlt, FaPhone, FaCalendarCheck, FaLeaf,
  FaTooth, FaHospital, FaArrowRight, FaCheckCircle,
  FaGlobe, FaWhatsapp, FaClock, FaStar,
  FaUserMd, FaAward, FaHeartbeat,
  FaRegLightbulb, FaShieldAlt, FaCertificate, FaUserCheck, FaCoins, FaUserShield, FaWallet,FaCheck, 
  FaLocationArrow,
  FaDirections 
} from 'react-icons/fa';
import { GiHairStrands, GiMedicalDrip, GiMedicalPack } from 'react-icons/gi';
import { MdFace, MdHealthAndSafety, MdOutlineHealthAndSafety, MdSupportAgent } from 'react-icons/md';
import { RiMentalHealthFill } from 'react-icons/ri';
import { BiBody } from 'react-icons/bi';
import tambaramskin from '../../../assets/images/tambaramskinicon.png';
import tambaramhair from '../../../assets/images/tambaramhairicon1.png';
import tambaramleaf from '../../../assets/images/tambaramleaf.jpg';
import tambarambanner3 from '../../../assets/images/tambarambanner4.png';
// Import combined Before-After images
import img1 from "../../../assets/images/autoscroll1.jpg";
import img2 from "../../../assets/images/autoscroll2.jpg";
import img3 from "../../../assets/images/autoscroll3.jpg";
import img4 from "../../../assets/images/autoscroll4.jpg";
import img5 from "../../../assets/images/autoscroll5.jpg";
import img6 from "../../../assets/images/autoscroll6.jpg";
import img7 from "../../../assets/images/autoscroll7.jpg";
import img8 from "../../../assets/images/autoscroll8.jpg";
import img9 from "../../../assets/images/autoscroll9.jpg";
import img10 from "../../../assets/images/autoscroll10.jpg";
import img11 from "../../../assets/images/autoscrollskin1.png";
import img12 from "../../../assets/images/autoscrollskin2.png";
import img13 from "../../../assets/images/autoscrollskin3.png";
import img14 from "../../../assets/images/autoscrollskin4.png";
import img15 from "../../../assets/images/autoscrollskin5.png";
import img16 from "../../../assets/images/autoscrollskin6.png";
import img17 from "../../../assets/images/autoscrollskin7.png";
import img18 from "../../../assets/images/autoscrollskin8.png";
import img19 from "../../../assets/images/autoscrollskin9.png";
import img20 from "../../../assets/images/autoscrollskin10.png"; 



import chennaitambarm from '../../../assets/images/chennaitambarmhair.jpg';
import chennaitambarmskin from '../../../assets/images/chennaitambaramskin.jpg';
import chennaitambaramhomeopathy from '../../../assets/images/chennaitambaramhomeopathy.png';
import chennaitambaramskin1 from '../../../assets/images/chennaitambaramskin1.jpg';
import chennaitambaramskin2 from '../../../assets/images/chennaitambaramskin2.jpg';
import chennaitambaramprp from '../../../assets/images/chennaitambaramprp.jpg';
import chennaitambaramgfc from '../../../assets/images/chennaitambarmgfc.png';
import chennaitambaramantiage from '../../../assets/images/chennaitambaramantiaging.jpg';
import chennaitambaramanstm from '../../../assets/images/chennaitambaramstm1.jpg';
import chennaitambaramandental from '../../../assets/images/chennaitambarmdental.jpg';
import chennaitambaramandental1 from '../../../assets/images/chennaitambaramdental1.jpg';
import chennaitambaramdentalinvisible from '../../../assets/images/chennaitambaramdentalinvisible.jpg';
import chennaitambarampcod from '../../../assets/images/chennaitambarampcos.jpg';
import chennaitambaramchronic from '../../../assets/images/chennaitambaramchronic.png';
import chennaitambarammentalhealth from '../../../assets/images/chennaitambarammentalhealth.jpg';
import laser1 from "./../../../assets/images/advanced-laser.jpg";
import chennaitambaramacne from '../../../assets/images/chennaitambaramacne.jpg';

import chennaitambaramcustamized from '../../../assets/images/chennaitambaramcustamized.png';
import chennaitambarampcos from '../../../assets/images/chennaitambarampcos1.jpg';
import chennaitambaramfaceprp from '../../../assets/images/chennaitambaramfaceprp.jpg';
import chennaitambaramc02 from '../../../assets/images/chennaitambaramc02.jpg';
import chennaitambaramrootcanal from '../../../assets/video/chennaitambaramrootcanal.mp4';
import chennaitambaramimplant from '../../../assets/images/chennaitambaramimplant.jpg';
import chennaitambaraminfertility from '../../../assets/images/chennaitambaraminfertility.jpg';
import chennaitambarameczema from '../../../assets/images/chennaitambarameczema.jpg';

import hcuraHeroVideo1 from '../../../assets/video/hcura-hero6.mp4';
import hcuraHeroVideo2 from '../../../assets/video/hcura-hero4.mp4';
import hcuraHeroVideo from '../../../assets/video/hcura-hero2.mp4';

const ICON_MAP = {
  'quality-icon': FaAward,
  'personalized-icon': FaUserCheck,
  'affordable-icon': FaCoins
};

const Icon = ({ name, size = 24, className = '', ariaHidden = true }) => {
  const Comp = ICON_MAP[name];
  if (!Comp) return <span className={className} aria-hidden={ariaHidden} />;
  return <Comp size={size} className={className} aria-hidden={ariaHidden} />;
};

const HCuraChennai = () => {
  const [activeLocation, setActiveLocation] = useState('tambaram');
  const [activeService, setActiveService] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isChanging, setIsChanging] = useState(false);
  const sectionRef = useRef(null);
  const servicesRef = useRef(null);
useEffect(() => {
  document.title = "H-Cura Multispecialty Clinic Tambaram Chennai | Hair, Skin, Dental & Homeopathy Treatments";
  
  const metaDescription = document.querySelector("meta[name='description']");
  if (metaDescription) {
    metaDescription.setAttribute(
      "content",
      "H-Cura Multispecialty Clinic in Tambaram Chennai offers advanced Hair Fall Treatment, Skin Care, Dental Solutions, and Homeopathy. Expert doctors, modern technology, proven results for Tambaram East, West, Chromepet, Pallavaram areas."
    );
  }
  
  const metaKeywords = document.querySelector("meta[name='keywords']");
  if (metaKeywords) {
    metaKeywords.setAttribute(
      "content",
      "H-Cura Tambaram, Hair Treatment Tambaram, Skin Clinic Tambaram, Dental Care Tambaram, Homeopathy Tambaram, PRP Hair Treatment, HydraFacial, Root Canal, PCOS Treatment, multispecialty clinic Chennai, hair fall treatment Chennai, skin whitening Tambaram, dental implants Chennai, homeopathy clinic Chennai, laser hair removal Tambaram"
    );
  }
  
  // Set canonical link
  const existingCanonical = document.querySelector("link[rel='canonical']");
  if (existingCanonical) {
    existingCanonical.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-tambaram-chennai");
  } else {
    const canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", "https://www.h-cura.com/multispecialty-clinic-in-tambaram-chennai  ");
    document.head.appendChild(canonicalLink);
  }
  
  // Set favicon (if you have one)
  // const existingFavicon = document.querySelector("link[rel='icon']");
  // if (existingFavicon) {
  //   existingFavicon.setAttribute("href", "/favicon.ico");
  // } else {
  //   const faviconLink = document.createElement("link");
  //   faviconLink.setAttribute("rel", "icon");
  //   faviconLink.setAttribute("type", "image/x-icon");
  //   faviconLink.setAttribute("href", "/favicon.ico");
  //   document.head.appendChild(faviconLink);
  // }
}, []);

  // NEW: auto-scroll state and ref
  const [isAutoScrollPaused, setIsAutoScrollPaused] = useState(false);
  const autoScrollRef = useRef(null);

  // Modal / viewer state (tambaram-prefixed)
  const [tambaramBaModalOpen, setTambaramBaModalOpen] = useState(false);
  const [tambaramBaModalItems, setTambaramBaModalItems] = useState([]);
  const [tambaramBaModalStartIndex, setTambaramBaModalStartIndex] = useState(0);

  const whyChooseControls = useAnimation();
  const [whyChooseRef, whyChooseInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
  const videos = document.querySelectorAll("video");

  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });
}, []);
  // Add these scrolling functions inside your component
  const scrollGallery = (direction) => {
    const container = document.getElementById('scrollableGrid');
    const cardWidth = 420; // Width of each card + gap
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    
    let newScrollPosition;
    if (direction === 'next') {
      newScrollPosition = Math.min(currentScroll + cardWidth, maxScroll);
    } else {
      newScrollPosition = Math.max(currentScroll - cardWidth, 0);
    }
    
    container.scrollTo({
      left: newScrollPosition,
      behavior: 'smooth'
    });
    
    updateScrollIndicators();
  };

  // Removed scrollToCard as jump dots are no longer present.

  const updateScrollIndicators = () => {
    const container = document.getElementById('scrollableGrid');
    const progressBar = document.getElementById('progressBar');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    
    if (!container || !progressBar) return;
    
    const scrollPercentage = (container.scrollLeft / (container.scrollWidth - container.clientWidth)) * 100;
    progressBar.style.width = `\${scrollPercentage}%`;
    
    // Update button states
    if (prevBtn) prevBtn.disabled = container.scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = container.scrollLeft >= (container.scrollWidth - container.clientWidth - 10);
  };

  // Add scroll event listener when modal opens
  useEffect(() => {
    if (tambaramBaModalOpen) {
      const container = document.getElementById('scrollableGrid');
      if (container) {
        container.addEventListener('scroll', updateScrollIndicators);
        updateScrollIndicators(); // Initial call
        
        // Initial scroll to startIndex
        const cardWidth = 420; // Ensure this matches your CSS card width + gap
        container.scrollLeft = tambaramBaModalStartIndex * cardWidth;

        return () => {
          container.removeEventListener('scroll', updateScrollIndicators);
        };
      }
    }
  }, [tambaramBaModalOpen, tambaramBaModalStartIndex]); // Added tambaramBaModalStartIndex to dependencies

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (whyChooseInView) {
      whyChooseControls.start('visible');
    }
  }, [whyChooseControls, whyChooseInView]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // NEW: auto-advance effect for services every 10 seconds (pauses when isAutoScrollPaused true)
  useEffect(() => {
    // clear any existing interval
    if (autoScrollRef.current) {
      clearInterval(autoScrollRef.current);
      autoScrollRef.current = null;
    }

    if (!isAutoScrollPaused) {
      autoScrollRef.current = setInterval(() => {
        setActiveService(prev => {
          const next = (prev + 1) % advancedServices.length;
          // follow same change animation behavior
          setIsChanging(true);
          setTimeout(() => {
            setIsChanging(false);
          }, 300);
          return next;
        });
      }, 10000); // 10 seconds
    }

    return () => {
      if (autoScrollRef.current) {
        clearInterval(autoScrollRef.current);
        autoScrollRef.current = null;
      }
    };
  }, [isAutoScrollPaused /* keep advancedServices.length stable by reference in file */]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12,
      },
    },
  };

 const locations = {
    tambaram: {
   name: "Tambaram",
   address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
   phone: "+91 88700 01377",
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
   popularServices: [
     "PRP Hair Treatment",
     "Dental Fillings",
     "Acne & Skin Lightening",
     "Root Canal and Smile Design"
   ],
   specialties: "Hair Restoration & Dental Procedures",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai",
   video: hcuraHeroVideo1
 },
 valasaravakkam: {
   name: "Valasaravakkam",
   address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
   phone: "+91 88700 01377",
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
   popularServices: [
     "Braces and Orthodontics",
     "GFC Hair Therapy",
     "Pigmentation & Skin Whitening",
     "Anxiety & PCOS Homeopathy Treatment"
   ],
   specialties: "Skin Treatments & Women's Health",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai",
   video: hcuraHeroVideo1
 },
 gerugambakkam: {
   name: "Gerugambakkam",
   address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
   phone: "+91 88700 01377", 
   hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
   nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
   popularServices: [
     "Hair Loss Treatment",
     "Skin Problem Solutions", 
     "Complete Dental Care",
     "Natural Homeopathy Treatment"
   ],
   specialties: "Complete Healthcare Solutions",
   mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai",
   video: hcuraHeroVideo1
 }
 
   };

  const advancedServices = [
    {
      id: 'hair',
      title: 'Hair Advanced Treatments in Tambaram – PRP, GFC',
      subtitle: 'Restore Your Confidence',
      description: 'If you are struggling with hair thinning or bald patches, our Hair Fall Treatment in Tambaram is designed to give you visible results.',
      image: chennaitambarm,
      treatments: [
       {
  name: 'Laser Hair Removal Tambaram',
  description: 'Advanced laser technology for permanent hair reduction.',
  icon: 'laser-icon',
  image: laser1,
  benefits: ['Permanent hair reduction', 'Smooth skin results', 'Safe and effective', 'Long-lasting solution']
},
        {
          name: 'GFC Hair Treatment Tambaram',
          description: 'Advanced GFC therapy uses concentrated growth factors from your own blood to accelerate hair regeneration.',
          icon: 'gfc-icon',
          image: chennaitambaramgfc,
          benefits: ['Faster regrowth', 'Thicker hair density', 'Natural-looking results', 'Customized formulation']
        },
        {
          name: 'Customized Hair Fall Control Plans',
          description: 'Customized Hair Fall Control Plans offer personalized treatment combining GFC Hair Therapy with PRP Treatment after detailed scalp analysis, delivering permanent results with natural hairline design, minimal scarring, and quick recovery.',
          icon: 'prp-icon',
          // image: chennaitambaramanstm,
          image: chennaitambaramcustamized,
          benefits: ['Permanent results', 'Natural hairline design', 'Minimal scarring', 'Quick recovery']
        }
      ],
      testimonial: {
        quote: "After trying numerous products with no success, the PRP and GFC combination treatment at H-Cura completely transformed my hair. I've regained not just my hair, but my confidence too.",
        author: "Rajesh K.",
        location: "Chromepet"
      }
    },
    {
      id: 'skin',
      title: 'Skin Treatments in Tambaram – From Acne to Anti-Aging',
      subtitle: 'Radiant Skin, Timeless Beauty',
      description: 'Our Skin Clinic in Tambaram offers advanced dermatology and aesthetic care to help you look your best.',
      image: chennaitambarmskin,
      treatments: [
      {
  name: 'Advanced Acne Treatment in Tambaram',
  description: 'Comprehensive acne treatment combining medical-grade therapies, targeted extractions, and specialized serums to clear breakouts, reduce inflammation, and prevent future acne formation.',
  icon: 'acne-treatment-icon',
  image: chennaitambaramacne,
  benefits: ['Clears active breakouts', 'Reduces acne scars', 'Controls oil production', 'Prevents future acne', 'Anti-inflammatory therapy']
},

       {
  name: 'PRP Face Treatment Tambaram',
  description: 'Platelet-Rich Plasma therapy using your own blood to stimulate collagen production, reduce fine lines, and rejuvenate skin naturally for a youthful glow.',
  icon: 'pigmentation-icon',
  image: chennaitambaramfaceprp,
  benefits: ['Natural skin rejuvenation', 'Stimulates collagen growth', 'Reduces fine lines', 'Improves skin texture', 'Long-lasting results']
},

        {
  name: 'CO2 Carbon Facial Tambaram',
  description: 'Advanced carbon dioxide laser facial treatment that deeply exfoliates, tightens pores, stimulates collagen production, and instantly brightens skin for a refreshed, youthful appearance.',
  icon: 'carbon-facial-icon',
  image: chennaitambaramc02,
  benefits: ['Deep pore cleansing', 'Instant skin tightening', 'Reduces blackheads', 'Stimulates collagen', 'No downtime required']
}

      ],
      testimonial: {
        quote: "The HydraFacial treatment at H-Cura gave me instant results that just kept getting better. My skin hasn't looked this good in years!",
        author: "Priya M.",
        location: "Tambaram East"
      }
    },
    {
      id: 'dental',
      title: 'Dental Care in Tambaram – Advanced, Painless & Affordable',
      subtitle: 'Perfect Smiles, Painlessly Delivered',
      description: 'Your smile is your biggest asset, and our Dental Clinic in Tambaram ensures it stays perfect..',
      image: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      treatments: [
       {
  name: 'Root Canal Treatment Tambaram',
  description: 'Pain-free, quick recovery, and lasting results.',
  icon: 'smile-icon',
  video: chennaitambaramrootcanal,
  benefits: ['Preview results', 'Customized planning', 'Precise implementation', 'Stunning aesthetics']
},
        {
          name: 'Dental Implants Tambaram',
          description: 'Replace missing teeth with permanent, natural-looking solutions.',
          icon: 'rootcanal-icon',
          image: chennaitambaramimplant,
          benefits: ['Pain-free procedure', 'Single-sitting options', 'Preserves natural tooth', 'Long-lasting results']
        },
        {
          name: 'Invisible Orthodontics',
          description: 'Clear aligner technology for teeth straightening without metal braces, custom-designed for your smile.',
          icon: 'aligner-icon',
          image: chennaitambaramdentalinvisible,
          benefits: ['Nearly invisible', 'Removable aligners', 'Comfortable fit', 'Fewer clinic visits']
        }
      ],
      testimonial: {
        quote: "The digital smile design process at H-Cura let me see my new smile before committing to treatment. The results are even better than I imagined!",
        author: "Vikram S.",
        location: "Pallavaram"
      }
    },
    {
      id: 'homeopathy',
      title: 'Homeopathy in Tambaram – Natural Healing for All Ages',
      subtitle: 'Natural Healing, Lasting Wellness',
      description: "Classical homeopathic treatments integrated with modern medical understanding for comprehensive health solutions and Our Homeopathy Clinic in Tambaram provides safe, effective, and long-lasting relief for various health conditions",
      image: chennaitambaramhomeopathy,
      treatments: [
    {
  name: 'Eczema Treatment in Tambaram',
  description: 'Struggling with itchy, irritated skin? Our eczema specialists in Tambaram help you find real relief. We create a treatment plan just for you to calm your skin, reduce flare-ups, and get back to feeling comfortable in your own skin.',
  icon: 'constitutional-icon',
  image: chennaitambarameczema,
  benefits: ['Stops the itch', 'Treats root cause', 'Safe for all ages', 'Quick relief']
},

{
  name: 'PCOS/PCOD Treatment in Tambaram',
  description: 'Specialized homeopathic protocols to regulate hormones naturally and address PCOS/PCOD symptoms effectively. Comprehensive treatment for hormonal balance, menstrual regulation, and metabolic health restoration.',
  icon: 'hormonal-icon',
  // image: chennaitambaramchronic,
  image: chennaitambarampcos,
  benefits: ['Regulates cycles', 'Reduces symptoms', 'Balances hormones', 'Improves fertility', 'Manages weight', 'Controls insulin resistance']
},

        {
          name: 'Infertility Treatment in Tambaram',
          description: 'At H-Cura, we provide personalized infertility treatment in Tambaram designed to address the underlying causes of reproductive challenges. Our approach blends modern diagnostic methods with natural and holistic therapies to improve fertility and overall reproductive health',
          icon: 'chronic-icon',
          image: chennaitambaraminfertility,
          benefits: ['Reduces dependency on conventional drugs', 'Improves quality of life', 'Addresses underlying causes', 'Safe for all ages']
        }
      ],
      testimonial: {
        quote: "After years of struggling with PCOS and trying conventional treatments, H-Cura's homeopathic approach has finally regulated my cycles naturally.",
        author: "Divya R.",
        location: "Selaiyur"
      }
    }
  ];

  const testimonials = [
    {
      name: "Priya R.",
      location: "Valasaravakkam",
      text: "The PRP treatment at H-Cura completely transformed my hair loss problem. The doctors were thorough in their diagnosis and treatment plan.",
      rating: 5,
      service: "Hair Treatment"
    },
    {
      name: "Karthik M.",
      location: "Tambaram",
      text: "After struggling with chronic acne for years, the homeopathic approach at H-Cura finally gave me clear skin. Highly recommend their skin treatments.",
      rating: 5,
      service: "Skin Treatment"
    },
    {
      name: "Divya S.",
      location: "Gerugambakkam",
      text: "The dental team made my root canal procedure completely painless. Their modern facilities and caring approach made all the difference.",
      rating: 4,
      service: "Dental Care"
    }
  ];

  const features = [
    {
      icon: <FaMapMarkerAlt />,
      title: "Prime Location",
      description: "Situated in the heart of Tambaram, Chennai, our clinic is easily accessible to both East Tambaram and West Tambaram residents with excellent transport connectivity.",
      highlight: "Easy Access"
    },
    {
      icon: <FaUserMd />,
      title: "Expert Specialists",
      description: "Whether you're looking for Hair Loss Treatment, Skin Rejuvenation, Smile Designing, or Homeopathy, our multi-specialty doctors ensure the right treatment.",
      highlight: "Specialized Care"
    },
    {
      icon: <GiMedicalPack />,
      title: "Advanced Technology",
      description: "We combine cutting-edge medical equipment with clinically proven techniques for PRP Hair Treatment, Laser Skin Treatments, and Digital Dentistry.",
      highlight: "Modern Equipment"
    },
    {
      icon: <FaHeartbeat />,
      title: "Holistic Healing",
      description: "Our Homeopathy Clinic focuses on long-term health improvement — treating the root cause rather than just symptoms with safe, natural remedies.",
      highlight: "Natural Wellness"
    },
    {
      icon: <FaAward />,
      title: "Proven Results",
      description: "With hundreds of success stories, 5-star reviews, and loyal repeat patients, H-Cura Tambaram has earned a strong reputation for trust and quality.",
      highlight: "Success Stories"
    },
    {
      icon: <FaRegLightbulb />,
      title: "Personalized Care",
      description: "Our specialist doctors take time to listen, assess, and create customized treatment plans for hair, skin, dental, or overall health needs.",
      highlight: "Tailored Treatments"
    },
    {
      icon: <MdOutlineHealthAndSafety />,
      title: "Safety Standards",
      description: "Stringent sterilization protocols, FDA-approved products, and international hygiene standards ensure your complete safety during treatments.",
      highlight: "Medical Safety"
    },
    {
      icon: <MdSupportAgent />,
      title: "Continuous Support",
      description: "Ongoing follow-ups, emergency assistance, and dedicated patient coordinators guide you throughout your treatment journey for optimal results.",
      highlight: "Patient Support"
    }
  ];

  const testimonialQuotes = [
    "The doctors at H-Cura truly listen and develop personalized treatment plans that work.",
    "After trying many clinics, H-Cura's holistic approach finally solved my chronic skin issues.",
    "Their attention to detail and focus on natural healing methods sets them apart in Chennai."
  ];

  const handleServiceChange = (index) => {
    setIsChanging(true);
    setTimeout(() => {
      setActiveService(index);
      setIsChanging(false);
    }, 300);
  };

  // helper to map service id to the proper Learn More page
  const serviceLearnMoreUrl = (serviceId) => {
    switch (serviceId) {
      case 'hair': return '/advanced-grow-hair-treatment';
      case 'skin': return '/advanced-hydrafacial-treatment';
      case 'dental': return '/dental-treatment';
      case 'homeopathy': return '/homeopathy-best-treatments/';
      default: return '/services';
    }
  };

  /*
    IMAGE / ICON MANAGEMENT (moved here into JSX inline styles)
    We map all image URLs used previously in CSS into JS maps and apply inline styles where those images were used.
  */
  const heroBackgroundUrl = tambarambanner3;
  const servicesBackgroundUrl = 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80';

  // icons for service tabs (same icons previously set in CSS background-image)
  const serviceIconMap = {
    hair: {
      url: tambaramhair,
      bgColor: 'rgba(255,154,158,0.12)',
      borderColor: 'rgba(255,154,158,0.18)',
      color: '#ff4d6d'
    },
    skin: {
      url: tambaramskin,
      bgColor: 'rgba(255,223,121,0.12)',
      borderColor: 'rgba(255,223,121,0.18)',
      color: '#ffb400'
    },
    dental: {
      url: 'https://img.icons8.com/fluency/48/000000/tooth.png',
      bgColor: 'rgba(144,238,144,0.12)',
      borderColor: 'rgba(144,238,144,0.18)',
      color: '#28a745'
    },
    homeopathy: {
      url: tambaramleaf,
      bgColor: 'rgba(135,206,250,0.12)',
      borderColor: 'rgba(135,206,250,0.18)',
      color: '#0099cc'
    }
  };

  // treatment bright icons (previously background-image in CSS)
  const treatmentIconMap = {
    'prp-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/syringe.png',
      bgColor: 'rgba(255,140,140,0.06)',
      borderColor: 'rgba(255,140,140,0.12)'
    },
    'gfc-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/biotech.png',
      bgColor: 'rgba(170,200,255,0.06)',
      borderColor: 'rgba(110,160,255,0.12)'
    },
    'transplant-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hair-care.png',
      bgColor: 'rgba(255,230,140,0.06)',
      borderColor: 'rgba(255,200,60,0.12)'
    },
    'hydrafacial-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/spa-care.png',
      bgColor: 'rgba(200,255,230,0.06)',
      borderColor: 'rgba(60,200,120,0.12)'
    },
    'pigmentation-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/foundation-makeup.png',
      bgColor: 'rgba(250,210,255,0.06)',
      borderColor: 'rgba(220,120,240,0.12)'
    },
    'antiaging-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/collagen.png',
      bgColor: 'rgba(220,245,255,0.06)',
      borderColor: 'rgba(80,200,240,0.12)'
    },
    'smile-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/happy-tooth.png',
      bgColor: 'rgba(200,255,220,0.06)',
      borderColor: 'rgba(80,200,120,0.12)'
    },
        'rootcanal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/tooth-cleaning.png',
      bgColor: 'rgba(255,240,200,0.06)',
      borderColor: 'rgba(240,180,60,0.12)'
    },
    'aligner-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/braces.png',
      bgColor: 'rgba(230,230,255,0.06)',
      borderColor: 'rgba(140,120,240,0.12)'
    },
    'constitutional-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/holistic-therapy.png',
      bgColor: 'rgba(240,240,255,0.06)',
      borderColor: 'rgba(160,160,240,0.12)'
    },
    'hormonal-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/hormone.png',
      bgColor: 'rgba(255,230,240,0.06)',
      borderColor: 'rgba(240,160,200,0.12)'
    },
    'chronic-icon': {
      url: 'https://img.icons8.com/fluency/48/000000/medical-pack.png',
      bgColor: 'rgba(230,255,240,0.06)',
      borderColor: 'rgba(160,240,200,0.12)'
    }
  };

  // SAMPLE gallery (10 per service) - correct syntax
  const SAMPLE_GALLERY = {
    hair: [
      {
        id: 'hair-1',
        title: 'Hair Restoration Case 1 - Male Pattern Hair Loss Treatment',
        combined: img1,
        testimonial: { quote: 'Amazing hair transformation in just 6 months with PRP treatment at H-Cura Tambaram!', author: 'Rajesh K.' }
      },
      {
        id: 'hair-2',
        title: 'Hair Growth Case 2 - Crown Area Hair Restoration',
        combined: img2,
        testimonial: { quote: 'PRP and GFC therapy gave me incredible results. Highly recommend H-Cura Tambaram!', author: 'Amit S.' }
      },
      {
        id: 'hair-3',
        title: 'Hair Treatment Case 3 - Receding Hairline Recovery',
        combined: img3,
        testimonial: { quote: 'My confidence is back with my natural-looking hairline from H-Cura!', author: 'Priya M.' }
      },
    {
        id: 'hair-4',
        title: 'Hair Case 4 - GFC and QR678 Treatment Success',
        combined: img4,
        testimonial: { quote: 'GFC and QR678 treatment gave me natural hair regrowth. Now I don\'t worry about hair loss anymore.', author: 'Karthik R.' }
      },

      {
        id: 'hair-5',
        title: 'Hair Restoration Case 5 - Natural Hair Regrowth',
        combined: img5,
        testimonial: { quote: 'Best decision I made for my hair health. Natural results at H-Cura!', author: 'Deepak V.' }
      },
      {
        id: 'hair-6',
        title: 'Hair Density Case 6 - Hair Volume Enhancement',
        combined: img6,
        testimonial: { quote: 'Visible hair density increase within 3 months of treatment in Tambaram.', author: 'Anitha L.' }
      },
      {
        id: 'hair-7',
        title: 'Hair Makeover Case 7 - Complete Hair Transformation',
        combined: img7,
        testimonial: { quote: 'Professional treatment with amazing outcomes. Thank you H-Cura Tambaram!', author: 'Suresh K.' }
      },
      {
        id: 'hair-8',
        title: 'Hair Recovery Case 8 - Hairline Restoration Success',
        combined: img8,
        testimonial: { quote: 'My family is amazed by the complete transformation at H-Cura.', author: 'Vikram P.' }
      },
      {
        id: 'hair-9',
        title: 'Hair Growth Case 9 - Hair Volume Enhancement',
        combined: img9,
        testimonial: { quote: 'H-Cura gave me back my youthful appearance and confidence in Tambaram.', author: 'Ramesh B.' }
      },
      {
        id: 'hair-10',
        title: 'Hair Treatment Case 10 - Hair Thickness Improvement',
        combined: img10,
        testimonial: { quote: 'Outstanding results that exceeded all my expectations at H-Cura!', author: 'Mahesh T.' }
      }
    ],
    
    skin: [
      {
        id: 'skin-1',
        title: 'Skin Treatment Case 1 - Acne Removal Success',
        combined: img11,
        testimonial: { quote: 'Clear skin after years of struggling with acne at H-Cura Tambaram!', author: 'Sneha R.' }
      },
      {
        id: 'skin-2',
        title: 'Skin Care Case 2 - Pigmentation Removal Treatment',
        combined: img12,
        testimonial: { quote: 'HydraFacial gave me the glow I always wanted in Tambaram.', author: 'Kavya M.' }
      },
      {
        id: 'skin-3',
        title: 'Anti-Aging Case 3 - Wrinkle Reduction Treatment',
        combined: img13,
        testimonial: { quote: 'Wrinkles reduced significantly with laser treatment at H-Cura.', author: 'Meera K.' }
      },
      {
        id: 'skin-4',
        title: 'Skin Whitening Case 4 - Skin Tone Improvement',
        combined: img14,
        testimonial: { quote: 'Even skin tone achieved naturally and safely in Tambaram.', author: 'Preethi S.' }
      },
      {
        id: 'skin-5',
        title: 'Melasma Treatment Case 5 - Dark Spot Removal',
        combined: img15,
        testimonial: { quote: 'Dark patches completely gone after treatment at H-Cura!', author: 'Divya L.' }
      },
      {
        id: 'skin-6',
        title: 'Skin Rejuvenation Case 6 - Youthful Skin Restoration',
        combined: img16,
        testimonial: { quote: 'Youthful skin restored with advanced treatments in Tambaram.', author: 'Anjali P.' }
      },
      {
        id: 'skin-7',
        title: 'Acne Scar Case 7 - Scar Removal Treatment',
        combined: img17,
        testimonial: { quote: 'Smooth skin texture achieved after scar treatment at H-Cura.', author: 'Rohit M.' }
      },
      {
        id: 'skin-8',
        title: 'Dark Circle Case 8 - Under Eye Treatment',
        combined: img18,
        testimonial: { quote: 'Bright, refreshed eyes after under-eye treatment in Tambaram.', author: 'Lakshmi V.' }
      },
      {
        id: 'skin-9',
        title: 'Skin Tightening Case 9 - Firm Skin Treatment',
        combined: img19,
        testimonial: { quote: 'Firm, tight skin without surgery. Amazing results at H-Cura!', author: 'Sunita K.' }
      },
      {
        id: 'skin-10',
        title: 'Overall Skin Health Case 10 - Complete Skin Transformation',
        combined: img20,
        testimonial: { quote: 'Complete skin transformation with holistic approach in Tambaram.', author: 'Ravi S.' }
      }
    ],
    
    dental: [
      {
        id: 'dental-1',
        title: 'Dental Case 1 - Smile Makeover Transformation',
        combined: 'https://images.unsplash.com/photo-1606811971618-4486d14f3f99?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect smile achieved with digital smile design at H-Cura Tambaram!', author: 'Arun K.' }
      },
      {
        id: 'dental-2',
        title: 'Teeth Whitening Case 2 - Bright White Smile',
        combined: 'https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Bright, white teeth in just one session in Tambaram!', author: 'Priya R.' }
      },
      {
        id: 'dental-3',
        title: 'Dental Implants Case 3 - Missing Tooth Replacement',
        combined: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural-looking teeth replacement. Excellent work at H-Cura!', author: 'Suresh M.' }
      },
      {
        id: 'dental-4',
        title: 'Orthodontic Case 4 - Straight Teeth Treatment',
        combined: 'https://images.unsplash.com/photo-1601568544619-9e77545a0c94?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Straight teeth with invisible braces. Amazing results in Tambaram!', author: 'Kavitha S.' }
      },
      {
        id: 'dental-5',
        title: 'Root Canal Case 5 - Pain-Free Tooth Treatment',
        combined: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Painless root canal treatment. Saved my tooth at H-Cura!', author: 'Ramesh P.' }
      },
      {
        id: 'dental-6',
        title: 'Gum Treatment Case 6 - Healthy Gums Restoration',
        combined: 'https://images.unsplash.com/photo-1542736667-069246bdbc6d?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Healthy gums restored with laser treatment in Tambaram.', author: 'Deepa L.' }
      },
      {
        id: 'dental-7',
        title: 'Crown & Bridge Case 7 - Tooth Restoration',
        combined: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Perfect fit crowns. Natural appearance achieved at H-Cura!', author: 'Vikram R.' }
      },
      {
        id: 'dental-8',
        title: 'Cosmetic Dentistry Case 8 - Beautiful Smile Design',
        combined: 'https://images.unsplash.com/photo-1555708982-8645ec6618c7?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete smile transformation. Confidence restored in Tambaram!', author: 'Anitha M.' }
      },
      {
        id: 'dental-9',
        title: 'Kids Dentistry Case 9 - Child-Friendly Treatment',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Child-friendly treatment. No more dental fear at H-Cura!', author: 'Sita K.' }
      },
      {
        id: 'dental-10',
        title: 'Full Mouth Case 10 - Complete Dental Restoration',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete oral health restored. Life-changing results in Tambaram!', author: 'Mahesh V.' }
      }
    ],
    
    homeopathy: [
      {
        id: 'homeopathy-1',
        title: 'PCOS Treatment Case 1 - Hormonal Balance Restoration',
        combined: 'https://images.unsplash.com/photo-1577003833619-76bbd7f82948?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Natural PCOS treatment regulated my cycles perfectly at H-Cura Tambaram!', author: 'Divya R.' }
      },
      {
        id: 'homeopathy-2',
        title: 'Chronic Illness Case 2 - Natural Healing Success',
        combined: 'https://images.unsplash.com/photo-1505751171710-1f6d0ace5a85?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Holistic approach cured my chronic condition naturally in Tambaram.', author: 'Raj M.' }
      },
      {
        id: 'homeopathy-3',
        title: 'Infertility Treatment Case 3 - Fertility Restoration',
        combined: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Blessed with a baby after homeopathic treatment at H-Cura!', author: 'Preethi S.' }
      },
      {
        id: 'homeopathy-4',
        title: 'Anxiety Treatment Case 4 - Mental Health Improvement',
        combined: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Mental peace achieved through natural remedies in Tambaram.', author: 'Arjun K.' }
      },
      {
        id: 'homeopathy-5',
        title: 'Digestive Issues Case 5 - Stomach Problem Relief',
        combined: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Digestive problems resolved without side effects at H-Cura.', author: 'Meera L.' }
      },
      {
        id: 'homeopathy-6',
        title: 'Skin Allergies Case 6 - Allergy Treatment Success',
        combined: 'https://images.unsplash.com/photo-1594824111567-8b5d7e0d5ad6?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic skin allergies cured permanently in Tambaram!', author: 'Sundar R.' }
      },
      {
        id: 'homeopathy-7',
        title: 'Respiratory Issues Case 7 - Breathing Problem Relief',
        combined: 'https://images.unsplash.com/photo-1580618672591-eb180b1a973f?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Breathing problems resolved with gentle treatment at H-Cura.', author: 'Lakshmi P.' }
      },
      {
        id: 'homeopathy-8',
        title: 'Joint Pain Case 8 - Arthritis Pain Relief',
        combined: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Arthritis pain reduced significantly without drugs in Tambaram.', author: 'Raman V.' }
      },
      {
        id: 'homeopathy-9',
        title: 'Migraine Treatment Case 9 - Headache Relief',
        combined: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Chronic migraines eliminated with homeopathy at H-Cura.', author: 'Kavya M.' }
      },
      {
        id: 'homeopathy-10',
        title: 'Overall Wellness Case 10 - Complete Health Transformation',
        combined: 'https://images.unsplash.com/photo-1598300042247-d088f8ab3a91?q=80&w=1200&auto=format&fit=crop&ixlib=rb-4.0.3',
        testimonial: { quote: 'Complete health transformation through natural healing in Tambaram.', author: 'Deepak S.' }
      }
    ]
  };

  // autoplay toggle state per thumbnail: before -> after every ~5s
  const [thumbnailFlipState, setThumbnailFlipState] = useState({
    hair: Array(10).fill(false),
    skin: Array(10).fill(false),
    dental: Array(10).fill(false),
    homeopathy: Array(10).fill(false)
  });

  useEffect(() => {
    const timers = [];
    Object.keys(SAMPLE_GALLERY).forEach((svcKey) => {
      SAMPLE_GALLERY[svcKey].forEach((_, idx) => {
        const t = setInterval(() => {
          setThumbnailFlipState(prev => {
            const copy = { ...prev };
            copy[svcKey] = copy[svcKey].slice();
            copy[svcKey][idx] = !copy[svcKey][idx];
            return copy;
          });
        }, 5000 + idx * 250);
        timers.push(t);
      });
    });
    return () => timers.forEach(t => clearInterval(t));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openTambaramBaModal = (serviceKey, startIndex = 0) => {
    setTambaramBaModalItems(SAMPLE_GALLERY[serviceKey]);
    setTambaramBaModalStartIndex(startIndex);
    setTambaramBaModalOpen(true);
    document.body.style.overflow = 'hidden';
    // Initial scroll will be handled by useEffect now
  };

  const closeTambaramBaModal = () => {
    setTambaramBaModalOpen(false);
    setTambaramBaModalItems([]);
    setTambaramBaModalStartIndex(0);
    document.body.style.overflow = '';
  };

  return (
    <div className="tambaram-hcura-chennai">
      {/* SEO Meta Tags */}
      <head>
        <title>H-Cura Multispecialty Clinic Tambaram Chennai | Hair, Skin, Dental & Homeopathy Treatments</title>
        <meta name="description" content="H-Cura Multispecialty Clinic in Tambaram Chennai offers advanced Hair Fall Treatment, Skin Care, Dental Solutions, and Homeopathy. Expert doctors, modern technology, proven results." />
        <meta name="keywords" content="H-Cura Tambaram, Hair Treatment Tambaram, Skin Clinic Tambaram, Dental Care Tambaram, Homeopathy Tambaram, PRP Hair Treatment, HydraFacial, Root Canal, PCOS Treatment" />
        <meta property="og:title" content="H-Cura Multispecialty Clinic Tambaram Chennai" />
        <meta property="og:description" content="Advanced Hair, Skin, Dental & Homeopathy treatments in Tambaram. Expert care with proven results." />
        <meta property="og:image" content={tambarambanner3} />
        <meta property="og:url" content="https://h-cura.com/tambaram" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://h-cura.com/tambaram" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "name": "H-Cura Multispecialty Clinic Tambaram",
            "description": "Advanced Hair, Skin, Dental & Homeopathy treatments in Tambaram Chennai",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
              "addressLocality": "Tambaram",
              "addressRegion": "Chennai",
              "postalCode": "600045",
              "addressCountry": "IN"
            },
            "telephone": "+91 88700 01377",
            "url": "https://h-cura.com",
            "openingHours": "Mo-Sa 09:00-21:00, Su 10:00-15:00",
            "medicalSpecialty": ["Dermatology", "Trichology", "Dentistry", "Homeopathy"],
            "priceRange": "$$"
          })}
        </script>
      </head>

     {/* <section className="tambaram-hero" style={{ position: 'relative', overflow: 'hidden' }}>
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              zIndex: -2
            }}
          >
           <source src={hcuraHeroVideo} type="video/mp4" />
          </video>

          <div 
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
              zIndex: -1
            }}
          ></div>

        <div className="tambaram-hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="tambaram-main-heading"
          >
            H-Cura Multispecialty Clinic in Tambaram Chennai
          </motion.h1>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="tambaram-sub-heading"
          >
            Expert Hair, Skin, Dental & Homeopathy Treatments
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="tambaram-hero-description"
          >
            Welcome to H-Cura Multispecialty Clinic in Tambaram Chennai – your trusted destination for Hair Fall Treatment, Skin Care, Dental Solutions, and Natural Homeopathy.
            We combine advanced medical science with natural healing to offer world-class treatments in Hair, Skin, Dental, and Homeopathy – all under one roof.
            Our clinic serves patients from Tambaram East, Tambaram West, Selaiyur, Perungalathur, Chromepet, Mudichur, Medavakkam, Pallavaram, and nearby areas.
          </motion.p>
          
          <motion.div
            className="tambaram-hero-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <Link to="/bookconsultation" className="tambaram-primary-button">Book Appointment</Link>
            <a href="https://wa.me/918870001377" className="tambaram-secondary-button" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp /> WhatsApp Us
            </a>
          </motion.div>

          <motion.div
            className="tambaram-location-buttons"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.65 }}
          >
            <div className="location-header">
              <FaMapMarkerAlt className="location-icon" />
              <span>Get Directions</span>
            </div>
            
            <div className="location-nav-buttons">
              <Link to="/homeopathy-clinic-in-gerugambakkam-chennai/" className="location-nav-btn">
                <FaDirections />
                <span>Gerukambakkam</span>
              </Link>
              
              <Link to="/homeopathy-clinic-in-valasaravakkam-chennai/" className="location-nav-btn">
                <FaDirections />
                <span>Valasaravakkam</span>
              </Link>
              
              <Link to="/homeopathy-clinic-in-chennai/" className="location-nav-btn">
                <FaDirections />
                <span>Back</span>
              </Link>
            </div>
          </motion.div>

          <motion.div
            className="tambaram-clinic-location-tabs"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
          >
           
          </motion.div>

          <motion.div
            className="tambaram-specialties-row"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
          </motion.div>
        </div>
      </section> */}

      <section className="tambaram-hcura-hero-section" style={{ position: 'relative', overflow: 'hidden' }}>
  {/* Background Video */}
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
   <source src={hcuraHeroVideo} type="video/mp4" />
  </video>

  {/* Video Overlay */}
  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(41, 33, 33, 0.3), rgba(112, 111, 111, 0.3))',
      zIndex: -1
    }}
  ></div>

  <div className="tambaram-hcura-hero-content-wrapper">
    <motion.h1
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="tambaram-hcura-primary-title"
    >
      H-Cura Multispecialty Clinic in Tambaram Chennai
    </motion.h1>
    
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="tambaram-hcura-secondary-title"
    >
      Expert Hair, Skin, Dental & Homeopathy Treatments
    </motion.h2>
    
    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      className="tambaram-hcura-description-text"
    >
      Welcome to H-Cura Multispecialty Clinic in Tambaram Chennai – your trusted destination for Hair Fall Treatment, Skin Care, Dental Solutions, and Natural Homeopathy.
      We combine advanced medical science with natural healing to offer world-class treatments in Hair, Skin, Dental, and Homeopathy – all under one roof.
      Our clinic serves patients from Tambaram East, Tambaram West, Selaiyur, Perungalathur, Chromepet, Mudichur, Medavakkam, Pallavaram, and nearby areas.
    </motion.p>
    
    <motion.div
      className="tambaram-hcura-action-buttons"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.6 }}
    >
      <Link to="/bookconsultation" className="tambaram-hcura-btn-primary">Book Appointment</Link>
      <a href="https://wa.me/918870001377" className="tambaram-hcura-btn-secondary" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp /> WhatsApp Consult
      </a>
    </motion.div>

    <motion.div
      className="tambaram-hcura-location-navigation"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.65 }}
    >
      <div className="tambaram-hcura-location-header">
        <FaMapMarkerAlt className="tambaram-hcura-location-icon" />
        <span className="tambaram-hcura-location-title">Our Chennai Locations</span>
      </div>
      
      <div className="tambaram-hcura-location-buttons">
        <Link to="/multispecialty-clinic-in-gerugambakkam-chennai" className="tambaram-hcura-location-btn">
          <FaDirections />
          <span>Gerugambakkam</span>
        </Link>
        
        <Link to="/multispecialty-clinic-in-valasaravakkam-chennai/" className="tambaram-hcura-location-btn">
          <FaDirections />
          <span>Valasaravakkam</span>
        </Link>
        
        <Link to="/multispecialty-clinic-in-chennai/" className="tambaram-hcura-location-btn">
          <FaDirections />
          <span>Back</span>
        </Link>
      </div>
    </motion.div>
  </div>
</section>



      {/* DOCTORS */}
      {/* <section id="doctors" className="tambaram-doctors">
        <div className="tambaram-section-header">
          <span className="tambaram-section-subtitle">Meet Our Team</span>
          <h2>Our Specialist Doctors in Tambaram</h2>
          <div className="tambaram-decorative-line"><span className="tambaram-decorative-icon"><FaUserMd /></span></div>
          <p className="tambaram-section-description">Our experienced team of specialists — dermatologists, trichologists, dentists and homeopaths — deliver personalized care with modern diagnostics and caring follow-up.</p>
        </div>

        <div className="tambaram-doctors-grid">
          {[
            { name: "Dr. A. Ramesh", title: "Dermatologist", qualifications: "MD (Dermatology), Cosmetology", experience: "12 years", image: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=800&auto=format&fit=crop", alt: "Dr. A. Ramesh - Expert Dermatologist at H-Cura Tambaram", specialties: ["Acne & Pigmentation", "Laser Therapy"] },
            { name: "Dr. S. Priya", title: "Trichologist", qualifications: "DNB (Dermatology), Tricho", experience: "10 years", image: "https://images.unsplash.com/photo-1550831107-1553da8c8464?q=80&w=800&auto=format&fit=crop", alt: "Dr. S. Priya - Hair Treatment Specialist at H-Cura Tambaram", specialties: ["PRP & GFC", "Hair Transplants"] },
                       { name: "Dr. K. Vinod", title: "Dental Surgeon", qualifications: "MDS (Prosthodontics)", experience: "9 years", image: "https://images.unsplash.com/photo-1580281657521-1d5f5b61f4a7?q=80&w=800&auto=format&fit=crop", alt: "Dr. K. Vinod - Dental Specialist at H-Cura Tambaram", specialties: ["Implants", "Root Canal"] },
            { name: "Dr. N. Shalini", title: "Homeopath", qualifications: "BHMS", experience: "15 years", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=800&auto=format&fit=crop", alt: "Dr. N. Shalini - Homeopathy Expert at H-Cura Tambaram", specialties: ["PCOS/PCOD", "Chronic Care"] }
          ].map((doc, i) => (
            <motion.article key={i} className="tambaram-doctor-card" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }} aria-labelledby={`doctor-${i}-name`}>
              <div className="tambaram-doctor-media" style={{ backgroundImage: `url('${doc.image}')` }} role="img" aria-label={doc.alt} />
              <div className="tambaram-doctor-body">
                <h3 id={`doctor-${i}-name`}>{doc.name}</h3>
                <p className="tambaram-doctor-title">{doc.title} • {doc.qualifications}</p>
                <p className="tambaram-doctor-exp">{doc.experience} experience</p>
                <ul className="tambaram-doctor-specialties">{doc.specialties.map((s, si) => <li key={si}><FaCheckCircle className="tambaram-doctor-check" /> {s}</li>)}</ul>
                <div className="tambaram-doctor-cta">
                  <Link to="/bookconsultation" className="tambaram-doctor-book">Book with {doc.name.split(' ')[1]}</Link>
                  <a href={`https://wa.me/918870001377?text=Hi%20I%20want%20to%20book%20an%20appointment%20with%20${encodeURIComponent(doc.name)}`} className="tambaram-doctor-whatsapp" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp</a>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </section> */}

      {/* BEFORE & AFTER - Clean Single Images Only */}
      {/* <section id="before-after" className="tambaram-before-after">
        <div className="tambaram-section-header">
          <span className="tambaram-section-subtitle">Real Results</span>
          <h2>Before & After Gallery - Tambaram Patients</h2>
          <div className="tambaram-decorative-line"><span className="tambaram-decorative-icon"><FaArrowRight /></span></div>
          <p className="tambaram-section-description">Genuine patient transformations from our Tambaram clinic — each image shows complete before and after comparison. Click View Details for full gallery.</p>
        </div>

        <div className="tambaram-before-tabs">
          {['hair','skin','dental','homeopathy'].map((s, idx) => (
            <button key={s} className={`tambaram-ba-tab ${activeService === idx ? 'active' : ''}`} onClick={() => { handleServiceChange(idx); setIsAutoScrollPaused(true); setTimeout(()=>setIsAutoScrollPaused(false),10000); }} aria-pressed={activeService === idx}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <div className="tambaram-before-carousel-wrapper">
          <div className="tambaram-before-carousel" role="list" aria-label="Before after gallery">
            {(() => {
              const svcKey = activeService === 0 ? 'hair' : activeService === 1 ? 'skin' : activeService === 2 ? 'dental' : 'homeopathy';
              const items = SAMPLE_GALLERY[svcKey] || [];
              
              return items.map((item, idx) => (
                <article key={item.id} className="tambaram-ba-clean-card" role="listitem">
                  <div className="tambaram-ba-clean-container">
                    <div className="tambaram-ba-clean-image-wrapper">
                      <img 
                        src={item.combined} 
                        alt={`${item.title} transformation at H-Cura Tambaram`} 
                        className="tambaram-ba-clean-image"
                        title={`${item.title} - Before and After Results`}
                      />
                      <div className="tambaram-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="tambaram-ba-clean-actions">
                      <button 
                        className="tambaram-ba-clean-view-btn" 
                        onClick={() => openTambaramBaModal(svcKey, idx)}
                        aria-label={`View detailed results for ${item.title}`}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section> */}
      <section id="before-after" className="tambaram-before-after">
        <div className="tambaram-section-header">
          <span className="tambaram-section-subtitle">Real Results</span>
          <h2>Before & After Gallery - Tambaram Patients</h2>
          <div className="tambaram-decorative-line"><span className="tambaram-decorative-icon"><FaArrowRight /></span></div>
          <p className="tambaram-section-description">Genuine patient transformations from our Tambaram clinic — each image shows complete before and after comparison. Click View Details for full gallery.</p>
        </div>

        <div className="tambaram-before-tabs">
          {['hair','skin'].map((s, idx) => (
            <button key={s} className={`tambaram-ba-tab ${activeService === idx ? 'active' : ''}`} onClick={() => { handleServiceChange(idx); setIsAutoScrollPaused(true); setTimeout(()=>setIsAutoScrollPaused(false),10000); }} aria-pressed={activeService === idx}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </button>
          ))}
        </div>

        <div className="tambaram-before-carousel-wrapper">
          <div className="tambaram-before-carousel" role="list" aria-label="Before after gallery">
            {(() => {
              const svcKey = activeService === 0 ? 'hair' : 'skin';
              const items = SAMPLE_GALLERY[svcKey] || [];
              
              return items.map((item, idx) => (
                <article key={item.id} className="tambaram-ba-clean-card" role="listitem">
                  <div className="tambaram-ba-clean-container">
                    <div className="tambaram-ba-clean-image-wrapper">
                      <img 
                        src={item.combined} 
                        alt={`${item.title} transformation at H-Cura Tambaram`} 
                        className="tambaram-ba-clean-image"
                        title={`${item.title} - Before and After Results`}
                      />
                      <div className="tambaram-ba-clean-title">
                        <h4>{item.title}</h4>
                      </div>
                    </div>
                    <div className="tambaram-ba-clean-actions">
                      <button 
                        className="tambaram-ba-clean-view-btn" 
                        onClick={() => openTambaramBaModal(svcKey, idx)}
                        aria-label={`View detailed results for ${item.title}`}
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </article>
              ));
            })()}
          </div>
        </div>
      </section>


      {/* Modal viewer for detailed view with scrolling */}
      {tambaramBaModalOpen && (
        <div className="tambaram-ba-modal" role="dialog" aria-modal="true" aria-label="Before and after detailed gallery">
          <div className="tambaram-ba-modal-backdrop" onClick={closeTambaramBaModal} />
          <div className="tambaram-ba-modal-panel">
            <header className="tambaram-ba-modal-header">
              <h3>Treatment Results Gallery - H-Cura Tambaram</h3>
              <button className="tambaram-ba-modal-close" onClick={closeTambaramBaModal} aria-label="Close gallery">×</button>
            </header>

            <div className="tambaram-ba-modal-body">
              <div className="tambaram-ba-scrollable-container">
                <div className="tambaram-ba-scroll-track" id="scrollTrack">
                  <div className="tambaram-ba-scrollable-grid" id="scrollableGrid">
                    {tambaramBaModalItems.map((item, index) => (
                      <div key={item.id} className="tambaram-ba-scrollable-card" data-index={index}>
                        <div className="tambaram-ba-scrollable-image-container">
                          <img 
                            src={item.combined} 
                            alt={`${item.title} detailed transformation results`} 
                            className="tambaram-ba-scrollable-image"
                            title={`${item.title} - Complete Before After Results`}
                          />
                        </div>
                        <div className="tambaram-ba-scrollable-content">
                          <h4>{item.title}</h4>
                          <p className="tambaram-ba-scrollable-testimonial">"{item.testimonial?.quote || ''}"</p>
                          <div className="tambaram-ba-scrollable-author">— {item.testimonial?.author || ''}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                {/* Scroll Progress Bar */}
                <div className="tambaram-ba-scroll-progress">
                  <div className="tambaram-ba-progress-bar" id="progressBar"></div>
                </div>
              </div>

              {/* Enhanced Navigation Controls */}
              <div className="tambaram-ba-enhanced-controls">
                <div className="tambaram-ba-nav-buttons">
                  <button 
                    className="tambaram-ba-nav-btn tambaram-ba-prev-btn" 
                    id="prevBtn"
                    onClick={() => scrollGallery('prev')}
                    aria-label="Previous results"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                    </svg>
                    Previous
                  </button>
                  
                  <button 
                    className="tambaram-ba-nav-btn tambaram-ba-next-btn" 
                    id="nextBtn"
                    onClick={() => scrollGallery('next')}
                    aria-label="Next results"
                  >
                    Next
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WHY CHOOSE */}
      <section id="why-choose" className="tambaram-why-choose-enhanced">
        <div className="tambaram-curved-background">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,138.7C96,117,192,75,288,74.7C384,75,480,117,576,160C672,203,768,245,864,229.3C960,213,1056,139,1152,117.3C1248,96,1344,128,1392,144L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg>
        </div>

        <div className="tambaram-content-wrapper">
          <motion.div className="tambaram-section-header" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
            <span className="tambaram-section-subtitle">Excellence in Healthcare</span>
            <h2>Why Choose H-Cura Clinic in Tambaram Chennai?</h2>
            <div className="tambaram-decorative-line"><span className="tambaram-decorative-icon"><FaShieldAlt /></span></div>
            <p className="tambaram-section-description">Because your health, beauty, and confidence deserve a clinic that truly cares. At H-Cura Tambaram, we bring together specialist doctors, world-class technology, and a patient-first approach to give you the best possible results. Whether it's restoring your hair, rejuvenating your skin, enhancing your smile, or improving your overall wellness with homeopathy, we focus on treatments that are safe, effective, and tailored just for you. Conveniently located for both East & West Tambaram residents, we make advanced healthcare accessible, comfortable, and trustworthy — so you can step in with hope and step out with confidence.</p>
          </motion.div>

          <div className="tambaram-awards-banner">
            <div className="tambaram-award"><FaStar className="tambaram-award-icon" /><span>Best Dermatology Clinic 2024</span></div>
            <div className="tambaram-award"><FaCertificate className="tambaram-award-icon" /><span>ISO 9001:2015 Certified</span></div>
            <div className="tambaram-award"><FaAward className="tambaram-award-icon" /><span>Top Healthcare Provider</span></div>
          </div>

          <motion.div className="tambaram-features-grid" ref={whyChooseRef} variants={containerVariants} initial="hidden" animate={whyChooseControls}>
            {features.map((feature, index) => (
              <motion.div className="tambaram-feature-card-enhanced" key={index} variants={itemVariants}>
                <div className="tambaram-feature-header">
                  <div className="tambaram-icon-container">{feature.icon}<div className="tambaram-icon-glow"></div></div>
                  <span className="tambaram-feature-highlight">{feature.highlight}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="tambaram-feature-footer">
                  <div className="tambaram-feature-dots"><span className="tambaram-dot"></span><span className="tambaram-dot"></span><span className="tambaram-dot"></span></div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <div className="tambaram-testimonial-strip">
            <div className="tambaram-testimonial-background"></div>
            <div className="tambaram-testimonial-content">
              <div className="tambaram-quote-marks">"</div>
              <div className="tambaram-testimonial-slider">
                {testimonialQuotes.map((quote, index) => (
                  <div className="tambaram-testimonial-quote" key={index}><p>{quote}</p></div>
                ))}
              </div>
            </div>
          </div>

          <div className="tambaram-stats-container">
            <div className="tambaram-stat-box"><div className="tambaram-stat-number">5+</div><div className="tambaram-stat-label">Years of Excellence</div></div>
            <div className="tambaram-stat-box"><div className="tambaram-stat-number">10+</div><div className="tambaram-stat-label">Medical Experts</div></div>
            <div className="tambaram-stat-box"><div className="tambaram-stat-number">9k+</div><div className="tambaram-stat-label">Happy Patients</div></div>
            <div className="tambaram-stat-box"><div className="tambaram-stat-number">99%</div><div className="tambaram-stat-label">Success Rate</div></div>
          </div>

          <div className="tambaram-cta-container">
            <h3>Experience the H-Cura Difference</h3>
            <p>Join thousands of satisfied patients who have transformed their lives with our expert care.</p>
            <Link to="/bookconsultation" className="tambaram-cta-button">Book Your Consultation</Link>
          </div>
        </div>

        <div className="tambaram-curved-background-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#ffffff" fillOpacity="1" d="M0,160L48,181.3C96,203,192,245,288,229.3C384,213,480,139,576,128C672,117,768,171,864,197.3C960,224,1056,224,1152,213.3C1248,203,1344,181,1392,170.7L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
        </div>
      </section>

      <section id="services" className="tambaram-services-premium-section" ref={sectionRef}>
        <div
          className={`tambaram-services-background ${isVisible ? 'visible' : ''}`}
          style={{
            backgroundImage: `linear-gradient(to right, rgba(255,255,255,0.97), rgba(255,255,255,0.8)), url('${servicesBackgroundUrl}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            opacity: isVisible ? 1 : 0
          }}
        ></div>

        <div className="tambaram-services-container">
          <div className={`tambaram-services-header ${isVisible ? 'visible' : ''}`}>
            <span className="tambaram-services-subtitle">Excellence in Healthcare</span>
            <h2>Our Services at H-Cura Tambaram Chennai</h2>
            <div className="tambaram-services-separator"><span></span><div className="tambaram-separator-icon"></div><span></span></div>
            <p className="tambaram-services-description">Experience world-class treatments delivered with precision and care. Our comprehensive range of services combines advanced medical technology with natural healing approaches.</p>
          </div>

          <div
            className={`tambaram-services-tabs ${isVisible ? 'visible' : ''}`}
            ref={servicesRef}
            onMouseEnter={() => setIsAutoScrollPaused(true)}
            onMouseLeave={() => setIsAutoScrollPaused(false)}
            onFocus={() => setIsAutoScrollPaused(true)}
            onBlur={() => setIsAutoScrollPaused(false)}
          >
            {advancedServices.map((service, index) => {
              const sIcon = serviceIconMap[service.id] || null;
              const isActive = activeService === index;
              return (
                <button
                  key={service.id}
                  className={`tambaram-service-tab ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    setIsAutoScrollPaused(true);
                    handleServiceChange(index);
                    setTimeout(() => setIsAutoScrollPaused(false), 10000);
                  }}
                >
                  <span
                    className={`tambaram-tab-icon tambaram-${service.id}-icon bright-icon`}
                    style={{
                      backgroundImage: sIcon ? `url('${sIcon.url}')` : undefined,
                      backgroundSize: '60% auto',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      backgroundColor: sIcon ? sIcon.bgColor : undefined,
                      border: sIcon ? `2px solid ${sIcon.borderColor}` : undefined,
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      display: 'inline-block'
                    }}
                  ></span>
                  <span className="tambaram-tab-text">{service.title.split(' ')[0]}</span>
                  {isActive && <span className="tambaram-progress-bar"></span>}
                </button>
              );
            })}
          </div>

          <div className="tambaram-tab-indicators">
            {advancedServices.map((service, index) => (
              <span
                key={`indicator-${index}`}
                className={`tambaram-tab-indicator ${activeService === index ? 'active' : ''}`}
                onClick={() => {
                  setIsAutoScrollPaused(true);
                  handleServiceChange(index);
                  setTimeout(() => setIsAutoScrollPaused(false), 10000);
                }}
              ></span>
            ))}
          </div>

          <div className={`tambaram-service-content-wrapper ${isVisible ? 'visible' : ''}`}>
            <div className={`tambaram-service-main-content ${isChanging ? 'changing' : ''}`}>
              <div className="tambaram-service-info">
                <h3>{advancedServices[activeService].title}</h3>
                <h4>{advancedServices[activeService].subtitle}</h4>
                <p>{advancedServices[activeService].description}</p>

                <div className="tambaram-service-cta">
                  <Link to="/bookconsultation" className="tambaram-service-btn">Book Consultation</Link>
                  <Link to={serviceLearnMoreUrl(advancedServices[activeService].id)} className="tambaram-service-link">
                    Learn More <span className="tambaram-arrow-icon">→</span>
                  </Link>
                </div>
              </div>

              <div className="tambaram-service-image-container">
                <div className="tambaram-service-image-wrapper">
                  <img
                    src={advancedServices[activeService].image}
                    alt={`${advancedServices[activeService].title} at H-Cura Tambaram`}
                    className="tambaram-service-main-image"
                    title={`${advancedServices[activeService].title} - Advanced Treatment`}
                  />
                  <div className="tambaram-image-overlay"></div>
                  <div className="tambaram-service-badge"><span>Premium Care</span></div>
                </div>
              </div>
            </div>

            <div className="tambaram-service-treatments">
  <h4>Specialized Treatments</h4>
  <div className="tambaram-treatments-slider">
    {advancedServices[activeService].treatments.map((treatment, tIndex) => {
      const tIcon = treatmentIconMap[treatment.icon] || null;
      return (
        <div className="tambaram-treatment-card" key={tIndex}>
          <div className="tambaram-treatment-image">
            {treatment.video ? (
              <video
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '8px'
                }}
              >
                <source src={treatment.video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <img 
                src={treatment.image} 
                alt={`${treatment.name} at H-Cura Tambaram`} 
                title={`${treatment.name} - Professional Treatment`} 
              />
            )}
          </div>
          <div className="tambaram-treatment-content">
            <div
              className={`tambaram-treatment-icon tambaram-${treatment.icon} bright-treatment-icon`}
              style={{
                backgroundImage: tIcon ? `url('${tIcon.url}')` : undefined,
                backgroundSize: '60% auto',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundColor: tIcon ? tIcon.bgColor : undefined,
                border: tIcon ? `2px solid ${tIcon.borderColor}` : undefined,
                width: '56px',
                height: '56px',
                borderRadius: '12px',
              }}
            ></div>
            <h5>{treatment.name}</h5>
            <p>{treatment.description}</p>
            <div className="tambaram-treatment-benefits">
              <h6>Benefits:</h6>
              <ul>
                {treatment.benefits.map((benefit, i) => (
                  <li key={i}><span className="tambaram-benefit-icon">✓</span>{benefit}</li>
                ))}
              </ul>
            </div>

            <div className="tambaram-treatment-cta">
              <Link
                className="tambaram-treatment-learnmore"
                to={serviceLearnMoreUrl(advancedServices[activeService].id)}
              >
                Learn More
              </Link>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</div>


            <div className="tambaram-service-testimonial">
              <div className="tambaram-testimonial-content">
                <div className="tambaram-quote-icon">"</div>
                <p>{advancedServices[activeService].testimonial.quote}</p>
                <div className="tambaram-testimonial-author"><strong>{advancedServices[activeService].testimonial.author}</strong> | {advancedServices[activeService].testimonial.location}</div>
              </div>
              <div className="tambaram-testimonial-decoration"></div>
            </div>

            <div className="tambaram-service-stats">
              <div className="tambaram-stat-item"><div className="tambaram-stat-number">98<span>%</span></div><div className="tambaram-stat-label">Patient Satisfaction</div></div>
              <div className="tambaram-stat-item"><div className="tambaram-stat-number">5000<span>+</span></div><div className="tambaram-stat-label">Successful Treatments</div></div>
              <div className="tambaram-stat-item"><div className="tambaram-stat-number">15<span>+</span></div><div className="tambaram-stat-label">Years Experience</div></div>
              <div className="tambaram-stat-item"><div className="tambaram-stat-number">12<span>+</span></div><div className="tambaram-stat-label">Specialist Doctors</div></div>
            </div>

            <div className="tambaram-service-features">
              <div className="tambaram-feature">
                <div
                  className="tambaram-feature-icon tambaram-quality-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="quality-icon" size={28} />
                </div>
                <h5>Premium Quality</h5>
                <p>World-class treatments and technologies</p>
              </div>

              <div className="tambaram-feature">
                <div
                  className="tambaram-feature-icon tambaram-personalized-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="personalized-icon" size={28} />
                </div>
                <h5>Personalized Care</h5>
                <p>Customized treatment plans for each patient</p>
              </div>

              <div className="tambaram-feature">
                <div
                  className="tambaram-feature-icon tambaram-affordable-icon"
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  aria-hidden
                >
                  <Icon name="affordable-icon" size={28} />
                </div>
                <h5>Affordable Luxury</h5>
                <p>Premium care at reasonable prices</p>
              </div>
            </div>

            <div className="tambaram-service-action">
              <h4>Ready to Experience the H-Cura Difference?</h4>
              <p>Take the first step toward better health and confidence today.</p>
              <div className="tambaram-action-buttons">
                <Link to="/bookconsultation" className="tambaram-primary-action-btn">Book Appointment</Link>
                <Link to="/contact-us" className="tambaram-secondary-action-btn">Contact Us</Link>
              </div>
            </div>

            {/* <div className={`tambaram-services-partners ${isVisible ? 'visible' : ''}`}>
              <h4>Our Technology Partners</h4>
              <div className="tambaram-partners-logos">
                <div className="tambaram-partner-logo" style={{ backgroundImage: '', backgroundSize: '80% 80%' }}></div>
                <div className="tambaram-partner-logo" style={{ backgroundImage: '', backgroundSize: '80% 80%' }}></div>
                <div className="tambaram-partner-logo" style={{ backgroundImage: '', backgroundSize: '80% 80%' }}></div>
                <div className="tambaram-partner-logo" style={{ backgroundImage: '', backgroundSize: '80% 80%' }}></div>
                <div className="tambaram-partner-logo" style={{ backgroundImage: '', backgroundSize: '80% 80%' }}></div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section className="tambaram-stats-banner">
        <div className="tambaram-stat"><h3>10,000+</h3><p>Happy Patients</p></div>
        <div className="tambaram-stat"><h3>5+</h3><p>Years of Excellence</p></div>
        <div className="tambaram-stat"><h3>30+</h3><p>Specialist Doctors</p></div>
        <div className="tambaram-stat"><h3>3</h3><p>Convenient Locations</p></div>
      </section>

    <section id="locations" className="tambaram-locations">
  <div className="tambaram-section-header">
    <h2>Our Clinic Locations in Chennai</h2>
    <p>Find the nearest H-Cura clinic for your healthcare needs</p>
  </div>

  <div className="tambaram-location-tabs">
    {Object.keys(locations).map((loc) => (
      <Link
        key={loc}
        to={`/homeopathy-clinic-in-${loc}-chennai/`}
        className={`tambaram-location-tab ${
          activeLocation === loc ? "active" : ""
        }`}
      >
        <FaMapMarkerAlt /> {locations[loc].name}
      </Link>
    ))}
  </div>

  <div className="tambaram-location-details">
    <div className="tambaram-location-card">
      <div className="tambaram-location-header">
        <h3>{locations[activeLocation].name} Branch</h3>
        <span className="tambaram-specialty-tag">
          {locations[activeLocation].specialties}
        </span>
      </div>

      <div className="tambaram-location-grid">
        <div className="tambaram-location-info">
          <div className="tambaram-info-item">
            <FaMapMarkerAlt className="tambaram-info-icon" />
            <div>
              <h4>Address</h4>
              <p>{locations[activeLocation].address}</p>
              <p>
                <small>
                  Nearby: {locations[activeLocation].nearbyAreas}
                </small>
              </p>
            </div>
          </div>

          <div className="tambaram-info-item">
            <FaPhone className="tambaram-info-icon" />
            <div>
              <h4>Contact</h4>
              <p>{locations[activeLocation].phone}</p>
              <button
                className="tambaram-contact-button"
                onClick={() =>
                  (window.location.href = `tel:${locations[
                    activeLocation
                  ].phone.replace(/\s+/g, "")}`)
                }
              >
                Call Now
              </button>
            </div>
          </div>

          <div className="tambaram-info-item">
            <FaClock className="tambaram-info-icon" />
            <div>
              <h4>Working Hours</h4>
              <p>{locations[activeLocation].hours}</p>
            </div>
          </div>
        </div>

        <div className="tambaram-popular-services">
          <h4>Popular Services at {locations[activeLocation].name}</h4>
          <ul>
            {locations[activeLocation].popularServices.map(
              (service, index) => (
                <li key={index}>
                  <FaCheckCircle className="tambaram-check-icon" />
                  {service}
                </li>
              )
            )}
          </ul>
          <a
            href={locations[activeLocation].mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="tambaram-map-link"
          >
            View on Map <FaArrowRight />
          </a>
        </div>
      </div>
    </div>

    <div className="tambaram-location-image">
      <video
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "12px",
        }}
      >
        <source
          src={
            locations[activeLocation].video ||
            locations[activeLocation].image
          }
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</section>




      <section id="testimonials" className="tambaram-testimonials">
        <div className="tambaram-section-header"><h2>What Our Patients Say</h2><p>Real experiences from our valued patients</p></div>
        <div className="tambaram-testimonials-grid">
          {testimonials.map((testimonial, index) => (
                        <motion.div className="tambaram-testimonial-card" key={index} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.2 }}>
              <div className="tambaram-testimonial-rating">{[...Array(5)].map((_, i) => (<FaStar key={i} className={i < testimonial.rating ? "tambaram-star-filled" : "tambaram-star-empty"} />))}</div>
              <p className="tambaram-testimonial-text">"{testimonial.text}"</p>
              <div className="tambaram-testimonial-author">
                <div className="tambaram-author-info" title={`${testimonial.name} • ${testimonial.location} • ${testimonial.service}`}>
                  <h4 className="tambaram-testimonial-name">{testimonial.name}</h4>
                  <p className="tambaram-testimonial-meta">{testimonial.location} • {testimonial.service}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

     <section
  id="appointment"
  className="tambaram-appointment"
  style={{
    position: 'relative',
    color: '#fff',
  }}
>
  {/* Background Video */}
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: -2
    }}
  >
    <source src={hcuraHeroVideo2} type="video/mp4" />
  </video>

  {/* Video Overlay */}
  <div 
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.65))',
      zIndex: -1
    }}
  ></div>

  <div className="tambaram-appointment-content" role="region" aria-labelledby="appointment-heading">
    <motion.h2 id="appointment-heading" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>Book Your Appointment Today at H-Cura Tambaram</motion.h2>

    <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
      Take the first step toward better health and confidence. Schedule your visit with H-Cura Multispecialty Clinic in Tambaram Chennai.
    </motion.p>

    <motion.div className="tambaram-contact-options" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}>
      <div className="tambaram-contact-option"><FaPhone /> <span>+91 88700 01377 / 99646 88333</span></div>
      <div className="tambaram-contact-option"><FaGlobe /> <a href="https://h-cura.com" target="_blank" rel="noopener noreferrer">www.h-cura.com</a></div>
    </motion.div>

    <motion.div className="tambaram-appointment-buttons" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}>
      <Link to="/bookconsultation" className="tambaram-primary-button">Schedule Consultation</Link>
      <a href="https://wa.me/918870001377" className="tambaram-whatsapp-button" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> WhatsApp Us</a>
    </motion.div>
  </div>
</section>


    </div>
  );
};

export default HCuraChennai;
